var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGrownIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_403_4456",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_403_4456)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.9661 70.0522L77.0511 20.0847L58.8811 38.2547L49.7961 15.5422L40.7111 38.2547L22.541 20.0847L31.626 70.0522",
    stroke: "black",
    strokeWidth: 4.47999,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.627 70.0523L25.054 73.3411C24.2996 73.7181 23.665 74.2977 23.2213 75.0149C22.7777 75.7322 22.5424 76.5587 22.542 77.4021V88.2224H77.0521V77.4021C77.0517 76.5587 76.8164 75.7322 76.3728 75.0149C75.9291 74.2977 75.2945 73.7181 74.5401 73.3411L67.9671 70.0523H31.627Z",
    stroke: "black",
    strokeWidth: 4.47999,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.2549 15.5425C45.2549 16.7473 45.7335 17.9027 46.5854 18.7545C47.4372 19.6064 48.5926 20.085 49.7974 20.085C51.0021 20.085 52.1575 19.6064 53.0094 18.7545C53.8613 17.9027 54.3399 16.7473 54.3399 15.5425C54.3399 14.3378 53.8613 13.1824 53.0094 12.3305C52.1575 11.4786 51.0021 11 49.7974 11C48.5926 11 47.4372 11.4786 46.5854 12.3305C45.7335 13.1824 45.2549 14.3378 45.2549 15.5425Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 1.76,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 20.0847C18 21.2894 18.4786 22.4448 19.3305 23.2967C20.1824 24.1486 21.3378 24.6272 22.5425 24.6272C23.7473 24.6272 24.9027 24.1486 25.7545 23.2967C26.6064 22.4448 27.085 21.2894 27.085 20.0847C27.085 18.8799 26.6064 17.7245 25.7545 16.8727C24.9027 16.0208 23.7473 15.5422 22.5425 15.5422C21.3378 15.5422 20.1824 16.0208 19.3305 16.8727C18.4786 17.7245 18 18.8799 18 20.0847Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 1.76,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.5098 20.0847C72.5098 21.2894 72.9883 22.4448 73.8402 23.2967C74.6921 24.1486 75.8475 24.6272 77.0523 24.6272C78.257 24.6272 79.4124 24.1486 80.2643 23.2967C81.1162 22.4448 81.5948 21.2894 81.5948 20.0847C81.5948 18.8799 81.1162 17.7245 80.2643 16.8727C79.4124 16.0208 78.257 15.5422 77.0523 15.5422C75.8475 15.5422 74.6921 16.0208 73.8402 16.8727C72.9883 17.7245 72.5098 18.8799 72.5098 20.0847Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 1.76,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrownIcon);
export default __webpack_public_path__ + "static/media/grown-icon.99965229f41a5603921b88808e4efbdc.svg";
export { ForwardRef as ReactComponent };